<template>
  <div class="animated fadeIn fadeOut">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        mail
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">system</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">mail</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <strong class="title mr-auto mb7">Log Detail({{model.cmd}})</strong>
            <!-- <span class="float-right">Date : {{model.created_at | datetime}}</span> -->
          </div>
          <hr>
          <b-row class="row mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_title" v-b-tooltip.hover title="Title">Title</label><br>
            </b-col>
            <div class="col-xl-4 col-md-12  d-flex align-self-center">
              <label class="col-form-label" for="ph_title" v-if="model && model.title">{{model.title}}</label>
            </div>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_category" v-b-tooltip.hover title="Specifies the mail template classification">LEVEL</label><br>
            </b-col>
            <div class="col-xl-4 col-md-12  d-flex align-self-center">
              <v-select class="col-form-label" v-model="model.level" :options="codes.MAIL_LEVEL" label="name" ></v-select>
            </div>
          </b-row>
          <b-row class="row mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_partner" v-b-tooltip.hover title="The partner's information using this.">Partner</label>
            </b-col>
            <div class="col-xl-4 col-md-12  d-flex align-self-center">
              <label class="col-form-label" for="ph_partner" v-if="model && model.id &&  model.partner">{{model.partner && model.partner.username}}</label>
              <b-button v-else-if="!syncPartner && !lock" size="sm" variant="warning" @click="chainPartner = true">
                {{model.partner ? 'Change' : 'Connect'}} Partner
              </b-button>
              <span v-else>{{parnter_name}}</span>
            </div>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_description" v-b-tooltip.hover title="you can write some description here!">Description</label>
            </b-col>
            <div class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-input v-model="model.description"></b-input>
            </div>
            <!-- <b-col md="2" v-if="auth && auth.profile && auth.profile.permissions == 'Owner'">
              <b-form-group>
                <label for="ph_cmd" v-b-tooltip.hover title="recommend this text can change who only admin on site">System Code</label><br>
                <b-input :disabled="model && model.id ? true : false" v-model="model.cmd"></b-input>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_target" v-b-tooltip.hover title="Defines who uses mail templates">Target</label><br>
                <b-form-checkbox-group
                  v-model="model.target_list"
                  :options="codes.MAIL_TARGET"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col class="d-flex flex-wrap">
              <!-- <label for="ph_partner" v-b-tooltip.hover title="The partner's information using this.">* More option</label><br> -->
              <div class="mr-auto">
                <b-button style="display: inline-block;" block variant="outline-info" :disabled="!(model && model.id)" @click="sample_build"> Send Sample </b-button>
              </div>
              <div class="mr-2">
                <b-button variant="primary" @click="list"> List </b-button>
            
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-xl-6">
        <b-card class="text-center">
          <div class="row mb-2">
            <div class="col-xl-12 col-md-12 d-flex align-self-center">
              <b-button class="btn-block" style="display: inline-block;" variant="warning" @click="() => { model && model.id ? confirm_update = true : save() }"> Save </b-button>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-12 col-md-12  d-flex align-self-center">
              <b-input :state="model.title != null && model.title != '' ? true : false" class="" v-model="model.title"></b-input>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-12 col-md-12  d-flex align-self-center">
              <b-button class="btn-block" style="display: inline-block;" variant="success" @click="reset" :disabled="!(model && model.id)"> Reset </b-button>
            </div>
          </div>
          <codemirror style="text-align: left;" ref="CodeMirror" v-model="model.content" :options="cmOptions"/>
          <div class="row mb-2 mt-3">
            <div class="col-xl-12 col-md-12  d-flex align-self-center">
              <b-button class="btn-block" style="display: inline-block;" variant="danger" @click="confirm_remove = true" :disabled="!(model && model.id)"> Delete </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col lg="12" xl="6">
        <b-card>
          <label class="col-form-label">
            Title : {{model.title}}
          </label>
          <hr>
          <!-- <pre v-if="reload" v-html="model.content" style="background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px;" class="w-100 h-100 d-inline-block"></pre> -->
          <samp v-html="model.content" style="background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px; min-height: 1000px;" class="w-100 d-inline-block">
          </samp>
        </b-card>
      </b-col>
    </b-row>
  <!-- start modal area -->
  <b-modal title="Content Remove"  class="modal-danger" v-model="confirm_remove" @ok="remove" ok-variant="danger">
    Are you sure you want to delete the data?
  </b-modal>
  <b-modal title="Content Update"  class="modal-primary" v-model="confirm_update" @ok="save" ok-variant="primary">
    Are you sure you want to update the data?
  </b-modal>
  <b-modal size="xl" title="Find and select Partner" v-model="chainPartner" @ok="chainPartner = false" ok-variant="info">
    <Partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setPartner"></Partner-List>
  </b-modal>
  <b-modal size="ml" title="Set Sample Data"  class="modal-success" v-model="confirm_sample" @ok="send_sample" ok-variant="info" hide-footer>
    <table class="w-100 text-center">
      <thead>
        <tr>
          <th>key</th>
          <th>value</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(key, index) in Object.keys(sample_model)" v-bind:key="index">
          <td>{{key}}</td>
          <td>
            <b-input v-if="key.indexOf('_list') > -1" v-model="sample_model[key][0]"></b-input>
            <b-input v-else v-model="sample_model[key]"></b-input>
          </td>
        </tr>
      </tbody>
    </table>
    <hr>
    <b-button size="sm" class="m-1" block variant="warning" @click="send_sample"> Send Sample to me </b-button>
    <b-button size="sm" class="m-1" block variant="info" @click="confirm_sample = false"> Cancel </b-button>
  </b-modal>
</div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>

<style>
  .CodeMirror { height: 1000px !important; }
</style>